import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Integration {
  id: number;
  name: string;
  description: string;
  logo: string;
  integrated: boolean;
  category: string;
  providerKey?: string;
  status?: 'CONNECTED' | 'DISCONNECTED';
}

interface IntegrationsState {
  items: Integration[];
  loading: boolean;
  error: string | null;
}

const initialState: IntegrationsState = {
  items: [],
  loading: false,
  error: null,
};

const integrationsSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    setIntegrationState: (
      state,
      action: PayloadAction<{ id: number; integrated: boolean; status?: 'CONNECTED' | 'DISCONNECTED' }>
    ) => {
      const { id, integrated, status } = action.payload;
      const item = state.items.find((i) => i.id === id);
      if (item) {
        item.integrated = integrated;
        if (status) {
          item.status = status;
        } else {
          item.status = integrated ? 'CONNECTED' : 'DISCONNECTED';
        }
      }
    },
    setIntegrations: (
      state,
      action: PayloadAction<Integration[]>
    ) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearIntegrations: (state) => {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setIntegrationState, setIntegrations, setLoading, setError, clearIntegrations } = integrationsSlice.actions;
export default integrationsSlice.reducer;